
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CoachesAndTribeInfo extends Vue {
    @Prop() coachesAndTribeInfo: ICoachesAndTribeInfo;
    @Prop() coachesAndTribeTooltips: ICoachesAndTribeTooltips;
    @Prop() showNotCorrectLabel: boolean;
    @Prop() isHistorical: boolean;
}

export interface ICoachesAndTribeInfo {
    tribeName: string;
    emFullName: string;
    ltCoachFullName: string;
    firestaerterFullName: string;
}

export interface ICoachesAndTribeTooltips {
    tribeNameTooltip?: string;
    emFullNameTooltip?: string;
    ltCoachFullNameTooltip?: string;
    firestaerterTooltip?: string;
}
